import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span
        aria-hidden="true"
        className="pointer-events-none select-none text-9xl font-black leading-none text-background-200 md:text-[12rem]"
      >
        404
      </span>
      <div className="relative z-10 -mt-6">
        <h1 className="text-xl font-bold text-foreground-950 md:text-2xl">
          This page has not been generated
        </h1>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-600 md:text-lg">
          Tell me more about this page, so I can generate it
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-home-4-line text-base w-4 h-4 flex items-center justify-center"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}